import React from "react";
import { formatEventDate } from "../../utils/commonFunctions";
import { Button } from "antd";
import { EventStatusRender } from "../common/StatusRender";
import { DummyEvent } from "../../assets/images";

export default function EventCard({ data, manageEvent = () => {} }) {
  return (
    <div className="event-card">
      <div className="left-content">
        <div className="event-logo-info">
          <img src={DummyEvent} alt="" />
          <p className="event-date">
            {formatEventDate(data.start_date, data.end_date)}
          </p>
        </div>
        <div className="event-description">
          <h3>{data.event_title}</h3>
          <p>{data.hastag}</p>
          <p>
            <i className="fa-solid fa-user-group"></i> {data.users_count} Guests
            &nbsp;&nbsp;&nbsp;
            <i className="fa-solid fa-image"></i> {data.total_photos ?? 0} Photos
          </p>
        </div>
      </div>
      <div className="right-content">
        {data.status && <EventStatusRender value={data.status} />}
        <Button
          type="default"
          iconPosition="end"
          icon={<i className="fa-solid fa-arrow-up-right"></i>}
          onClick={() => {
            manageEvent(data);
          }}
        >
          Manage
        </Button>
      </div>
    </div>
  );
}
